"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const Error_1 = tslib_1.__importDefault(require("@mui/icons-material/Error"));
const InfoOutlined_1 = tslib_1.__importDefault(require("@mui/icons-material/InfoOutlined"));
const Button_1 = tslib_1.__importDefault(require("@mui/material/Button"));
const Dialog_1 = tslib_1.__importDefault(require("@mui/material/Dialog"));
const DialogActions_1 = tslib_1.__importDefault(require("@mui/material/DialogActions"));
const DialogContent_1 = tslib_1.__importDefault(require("@mui/material/DialogContent"));
const DialogTitle_1 = tslib_1.__importDefault(require("@mui/material/DialogTitle"));
const Divider_1 = tslib_1.__importDefault(require("@mui/material/Divider"));
const Grid_1 = tslib_1.__importDefault(require("@mui/material/Grid"));
const IconButton_1 = tslib_1.__importDefault(require("@mui/material/IconButton"));
const Typography_1 = tslib_1.__importDefault(require("@mui/material/Typography"));
const ButtonContactUs_1 = tslib_1.__importDefault(require("../ButtonContactUs"));
const CardActionsError_1 = tslib_1.__importDefault(require("../CardActionsError"));
const CardContentError_1 = tslib_1.__importDefault(require("../CardContentError"));
const CardError_1 = tslib_1.__importDefault(require("../CardError"));
const CardTitleError_1 = tslib_1.__importDefault(require("../CardTitleError"));
const useAggregatedError_1 = tslib_1.__importDefault(require("../_InternalUtils/useAggregatedError"));
/**
 *
 * @category component
 */
const PageGenericError = ({ small = false, contact = "mss@mnemonic.no", title = "Something went wrong", errorCardProps, error, }) => {
    const [dialogOpen, setDialogOpen] = (0, react_1.useState)(false);
    const { url, environment, timestamp, mappedErrorStack, message } = (0, useAggregatedError_1.default)(error);
    const body = `URL: ${url}\nEnvironment: ${environment}\nTimestamp: ${timestamp}\nMessage: ${message}\nError Stack: \n${mappedErrorStack}\n`;
    const bodyEmail = body.replace(/\n/g, "%0A");
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Grid_1.default, { container: true, justifyContent: "center", alignItems: "center", spacing: 1 },
            react_1.default.createElement(CardError_1.default, { ...errorCardProps },
                react_1.default.createElement(CardTitleError_1.default, { small: small, Icon: Error_1.default, colorIcon: "error", colorText: "error" }),
                react_1.default.createElement(CardContentError_1.default, { small: small, contact: contact }),
                react_1.default.createElement(CardActionsError_1.default, null,
                    react_1.default.createElement(Grid_1.default, { container: true, justifyContent: "space-between", alignItems: "baseline" },
                        react_1.default.createElement(Grid_1.default, { item: true },
                            react_1.default.createElement(ButtonContactUs_1.default, { email: contact, title: title, body: bodyEmail })),
                        react_1.default.createElement(Grid_1.default, { item: true },
                            react_1.default.createElement(IconButton_1.default, { size: "small", onClick: () => setDialogOpen(true) },
                                react_1.default.createElement(InfoOutlined_1.default, null))))))),
        react_1.default.createElement(Dialog_1.default, { open: dialogOpen, onClose: () => setDialogOpen(false), fullWidth: true, maxWidth: "md" },
            react_1.default.createElement(DialogTitle_1.default, null, title),
            react_1.default.createElement(DialogContent_1.default, null,
                react_1.default.createElement(Typography_1.default, null,
                    "Technical information",
                    react_1.default.createElement(Divider_1.default, null)),
                react_1.default.createElement(Typography_1.default, { variant: "caption", sx: { whiteSpace: "pre-line" } }, body)),
            react_1.default.createElement(DialogActions_1.default, null,
                react_1.default.createElement(ButtonContactUs_1.default, { email: contact, title: title, body: bodyEmail }),
                react_1.default.createElement(Button_1.default, { onClick: () => setDialogOpen(false) }, "Close")))));
};
exports.default = PageGenericError;
